import React, { useState, useEffect, useContext } from "react";
import { EnvironmentContext } from "../../EnvironmentContext";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import APIServices from "../../services/APIServices";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ButtonCompo from "../../Components/ButtonComponent/ButtonCompo";
import { setUserDetails } from "../../Redux/Actions";
import moment from "moment-timezone";
import "moment-timezone/data/packed/latest.json";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import MyTrips from "../../Components/myTrips";
import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import AlertComponent from "../../Components/Alert/Alert";
import { setAccessToken } from "../../Redux/Actions";
import apiconfig from "../../config/config";
const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    "&.Mui-focused fieldset": {
      border: "none",
    },
    backgroundColor: "transparent",
  },
  "& .MuiOutlinedInput-root.editMode fieldset": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
  },
}));

function CustomerDetail() {
  const { environment } = useContext(EnvironmentContext)
  const userDetails = useSelector((state) => state?.userDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [editProfileDetails, setEditProfileDetails] = useState(userDetails);
  const [showPassword, setShowPassword] = useState(false);
  const [updatedDetailsAlert, setUpdatedDetailsAlert] = useState(false);
  const [errAlert, setErrAlert] = useState(false);
  const accessToken = useSelector((state) => state.accessToken);
  const adminDetails = useSelector((state) => state?.loginUserDetails);
  const params = useParams();
  const id = params?.id;

  const adminMail = adminDetails?.mail
  const testingEnvironmentIds = {
    "support@meetbytravel.com": "669f4adac194ae7c8eb65d50",
    "jayadeep.mettela@ro-one.in": "665d4b21e27fc43df3215575"
  };

  const productionEnvironmentIds = {
    "support@meetbytravel.com": "669f4b370e0130ee414ef469",
    "jayadeep.mettela@ro-one.in": "66750b795ec6ba4ed5e33656"
  };

  let adminUserId;
  if (environment === "Production") {
    adminUserId = productionEnvironmentIds[adminMail];
  } else if (environment === "Testing") {
    adminUserId = testingEnvironmentIds[adminMail];
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));
    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    }
    else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }

    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      setIsLoading(true);
      APIServices.setAuthToken(tokenToUse);
      const url = environment === "Production"
        ? apiconfig.production.apiBaseUrl
        : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);
      APIServices.getUserByID(id, adminUserId)
        .then((response) => {
          dispatch(setUserDetails(response?.data?.user));
          console.log("User details from response: ", response?.data?.user);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("Error fetching user details: ", err);
          if (err?.response?.data?.message === "No data found") {
            alert("No user found with this profile ID")
          }
          setIsLoading(false);
        });
    }
  }, [id, accessToken, navigate, dispatch, environment, adminUserId]);

  const userMyTrips = userDetails?.my_events;
  const totalTrips = userDetails?.my_organized_trips?.length + userMyTrips?.length
  const cohostTripsCount = userMyTrips?.filter(
    (trip) => trip?.co_host === true
  );

  const userId = userDetails?._id;
  const getCancelledTrips = () => {
    const cancelledTrips = userMyTrips?.filter((trip) => {
      const userEvents = trip?.participants?.filter(
        (participantObj) =>
          participantObj.user_id?._id === userId && !participantObj?.full_name
      );
      const isTripConfirmed = userEvents?.find(
        (obj) =>
          obj?.slot_status === "confirmed" || obj?.slot_status === "waiting"
      );
      return (!isTripConfirmed)
    });
    return cancelledTrips;
  };

  const handleEditClick = () => {
    setEditable(!editable);
  };

  useEffect(() => {
    setEditProfileDetails(userDetails);
  }, [userDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name, value: ", name, value);

    setEditProfileDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSaveClick = () => {
    setIsLoading(true);
    const updatedUser = {
      firstName: editProfileDetails.firstName,
      lastName: editProfileDetails.lastName,
      gender: editProfileDetails.gender,
      city: editProfileDetails.city,
      country: editProfileDetails.country,
      lat: editProfileDetails.lat,
      lan: editProfileDetails.lan,
      profile_image: editProfileDetails.profile_image,
      mobile_number: editProfileDetails.mobile_number,
      describe_yourself: editProfileDetails.describe_yourself,
      share_your_travel_experience:
        editProfileDetails.share_your_travel_experience,
      your_hobbies: editProfileDetails.your_hobbies,
      countries_visited: editProfileDetails.countries_visited,
      my_organized_trips: editProfileDetails.my_organized_trips,
      food_preferences: editProfileDetails.food_preferences,
      date_of_birth: editProfileDetails.date_of_birth,
      no_of_trips: editProfileDetails.no_of_trips,
      cover_photo: editProfileDetails.cover_photo,
      password: editProfileDetails.password,
      form_verification: editProfileDetails.form_verification,
      terms_check: editProfileDetails.terms_check,
      kyc_verification: editProfileDetails.kyc_verification,
      signup_date: editProfileDetails.signup_date,
    };
    APIServices.updteUserDetails(userId, updatedUser)
      .then((response) => {
        console.log("response updated  : ", response?.data);
        dispatch(setUserDetails(response?.data?.updatedDetails));
        setEditable(false);
        setIsLoading(false);
        setUpdatedDetailsAlert(true)

      })
      .catch((err) => {
        console.log("Error in updating user", err);
        setIsLoading(false);
        setErrAlert(true)
      });
  };

  const inputProps = {
    readOnly: !editable,
    style: {
      edge: "end",
      cursor: editable ? "text" : "default",
      padding: "0px",
      fontFamily: "Poppins",
      width: "230px",
      height: "36px",
      boxSizing: "border-box",
      fontSize: "14px",

    },
  };

  const handleOrganiserForm = () => {
    console.log("View Organsier form button clicked");
    navigate(`/organiser-management/Viewedit/${userId}`);
  };

  const handleCancelClick = () => {
    setEditable(false);
  };
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div>
      <div className="event-information-bg-container">
        <Backdrop
          sx={{
            color: "#ffffff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <AlertComponent
          open={updatedDetailsAlert}
          severity="success"
          onClose={() => setUpdatedDetailsAlert(false)}
          text="User details updated successfully."
        />

        <AlertComponent
          open={errAlert}
          severity="error"
          onClose={() => setErrAlert(false)}
          text="Something went wrong.Please try again after sometime."
        />

        <div className="travellers-org-container-count">
          <div className="details-container-customer">
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Profile ID</h5>
              {editable ? (
                <TextField
                  size="small"
                  value={editProfileDetails?.profile_id || ""}
                  name="profile_id"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  disabled
                />
              ) : (
                <StyledTextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={userDetails?.profile_id || ""}
                  name="profile_id"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">First name</h5>
              {editable ? (
                <TextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={editProfileDetails?.firstName || ""}
                  name="firstName"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={userDetails?.firstName || ""}
                  name="firstName"
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Last name</h5>
              {editable ? (
                <TextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={editProfileDetails?.lastName || ""}
                  name="lastName"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={userDetails?.lastName || ""}
                  name="lastName"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Email ID</h5>
              {editable ? (
                <TextField
                  sx={{

                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={editProfileDetails?.email || ""}
                  name="email"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              ) : (
                <StyledTextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={userDetails?.email || ""}
                  name="email"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">
                Phone number
              </h5>
              {editable ? (

                <TextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small" placeholder="Enter mobile number"
                  value={editProfileDetails?.mobile_number || null}
                  name="mobile_number"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />

              ) : (
                <StyledTextField
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  size="small"
                  value={userDetails?.mobile_number || "NA"}
                  name="mobile_number"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">City</h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={editProfileDetails?.city || ""}
                  name="city"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.city || ""}
                  name="city"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Country</h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={editProfileDetails?.country || ""}
                  name="country"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.country || ""}
                  name="country"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">DOB</h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  // value={  moment(editProfileDetails?.date_of_birth).format( "DD/MM/YYYY"  ) || "NA" }
                  value={userDetails?.date_of_birth ? moment(userDetails?.date_of_birth).format("DD-MM-YYYY") : 'NA'}
                  name="date_of_birth"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  // value={userDetails?.date_of_birth || 'Null'}
                  // value={  moment(userDetails?.date_of_birth).format("DD/MM/YYYY") ||'NA' }
                  value={userDetails?.date_of_birth ? moment(userDetails?.date_of_birth).format("DD-MM-YYYY") : 'NA'}
                  name="date_of_birth"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container"  >
              <h5 className="information-side-heading-customer">Gender</h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={editProfileDetails?.gender || ""}
                  name="gender"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.gender || ""}
                  name="gender"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container"  >
              <h5 className="information-side-heading-customer">Password</h5>

              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={editProfileDetails?.password || ""}
                  name="password"
                  onChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  variant="outlined"
                  disabled
                  InputProps={{
                    ...inputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleTogglePasswordVisibility}
                        >
                          {showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.password || ""}
                  name="password"
                  fullWidth
                  variant="outlined"
                  disabled
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    ...inputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleTogglePasswordVisibility}
                        >
                          {showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

              )}
            </div>
          </div>

          <div className="details-container-customer" >
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">User status</h5>
              {editable ? (
                <TextField disabled
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={
                    editProfileDetails?.user_type === "user" ? "Traveller"
                      : editProfileDetails?.user_type === "admin" ? "Admin"
                        : "Trip Organiser"
                  }
                  name="user_type"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={
                    userDetails?.user_type === "user" ? "Traveller"
                      : userDetails?.user_type === "admin" ? "Admin"
                        : "Trip Organiser"

                  }
                  name="user_type"
                  // onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Total trips</h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={totalTrips || 0}
                  name="my_events"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={totalTrips || 0}
                  name="my_events"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>

            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Trips reserved</h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userMyTrips?.length || 0}
                  name="my_events"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userMyTrips?.length || 0}
                  name="my_events"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            {userDetails?.user_type === 'organiser' ? (<div className="details-content-container">
              <h5 className="information-side-heading-customer">
                Trips organised
              </h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.my_organized_trips?.length || 0}
                  name="my_organized_trips"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.my_organized_trips?.length || 0}
                  name="my_organized_trips"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>) : (null)
            }

            <div className="details-content-container">
              <h5 className="information-side-heading-customer">
                No of trips co-hosted
              </h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={cohostTripsCount?.length || 0}
                  name="cohostTripsCount"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={cohostTripsCount?.length || 0}
                  name="cohostTripsCount"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>

            <div className="details-content-container">
              <h5 className="information-side-heading-customer">Date joined</h5>
              {editable ? (
                <TextField disabled
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.signup_date[0] ? moment(userDetails.signup_date[0]).format("DD-MM-YYYY") : 'NA'}
                  name="dateJoined"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.signup_date[0] ? moment(userDetails.signup_date[0]).format("DD-MM-YYYY") : 'NA'}
                  name="dateJoined"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">
                No of trips cancelled as user
              </h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={getCancelledTrips()?.length || 0}
                  name="cancelled_trips"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={getCancelledTrips()?.length || 0}
                  name="cancelled_trips"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading-customer">
                Agreed to Terms and privacy
              </h5>
              {editable ? (
                <TextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.terms_check ? "Yes" : "No"}
                  name="terms_check"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                <StyledTextField
                  size="small"
                  sx={{
                    marginTop: "-10px",
                    fontFamily: "Poppins",
                    width: "230px",
                  }}
                  value={userDetails?.terms_check ? "Yes" : "No"}
                  name="terms_check"
                  onChange={handleChange}
                  InputProps={inputProps}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </div>
          </div>
        </div>

      </div>

      {editable ? (
        <div className="buttons-container">
          <ButtonCompo btnOutlined btnText="Save details" onClick={handleSaveClick} />
          <div>
            <ButtonCompo btnOutlined btnText="Cancel" onClick={handleCancelClick} />
          </div>
        </div>
      ) : (
        <div className="buttons-container">
          <ButtonCompo btnOutlined btnText="Edit details" onClick={handleEditClick} />
          {userDetails?.form_verification !== null ? (
            <div>
              <ButtonCompo btnOutlined btnText="View organiser form details" onClick={handleOrganiserForm} />
            </div>
          ) : null}

        </div>
      )}
      <MyTrips />
    </div>
  );
}

export default CustomerDetail;
